import React, {ChangeEvent, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

import "./AchRoutingNumberInput.scss";

interface AchRoutingNumberInputProps {
    achRoutingNumber: string;
    onSetAchRoutingNumber: (amount: string) => void;
    onSetIsAchRoutingNumberValid: (isAmountValid: boolean) => void;
}

export const AchRoutingNumberInput: React.FunctionComponent<AchRoutingNumberInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(true);
    const requiredAchRoutingNumberError = 'ACH Account is a required field.';

    useEffect(() => {
        props.onSetIsAchRoutingNumberValid(isValid);
    }, [isValid])

    const onChange = (event: ChangeEvent) => {
        let value = (event.target as HTMLInputElement).value;
        props.onSetAchRoutingNumber(value);
        validateAchRoutingNumber();
    }

    const onKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        validateAchRoutingNumber();
    }

    const validateAchRoutingNumber = () => {
        let errorsTemp: string[] = [];
        if (props.achRoutingNumber === '') {
            errorsTemp.push(requiredAchRoutingNumberError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div className="ach-routing-number-container">
        <Input isValid={isValid} type='text' required={true} value={props.achRoutingNumber} onChange={onChange}
               onKeyUp={onKeyUp}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
